// import ReactApexChart from "react-apexcharts";
// import { isMobileView } from "../../utils/Reusables";

// export default function TreeMapChart(props) {
//     let { resultSet, isLegendVisible, dateFieldFormat, columnDisplayName, columnTitle, settings, COLORS_SERIES } = props
//     let loadResponse = resultSet.series();
//     const tmp = loadResponse?.length > 0 && loadResponse[0]?.series?.map((obj) => {
//         return {
//             x: obj.x || "",
//             y: !obj?.value ? 0 : obj?.value
//         }
//     });

//     let filterTmp = []
//     if (tmp?.length) {
//         filterTmp = tmp?.filter(t => t?.x && t?.y && !isNaN(t?.y))
//     }

//     const series = [{ data: filterTmp }]

//     let title = loadResponse?.length > 0 ? handleChartLabel(columnTitle, columnDisplayName, loadResponse[0]) : "";

//     console.log(settings?.web?.maxLabelCharacters, "::settings?.web?.maxLabelCharacters");

//     const options = {
//         chart: {
//             type: "treemap",
//             toolbar: { show: false }
//         },
//         colors: COLORS_SERIES,
//         legend: { show: isLegendVisible },
//         title: { text: title, align: 'left' },
//         dataLabels: {
//             enabled: true,
//             style: {
//                 fontSize: '18px',
//             },
//             formatter: function (text, op) {

//                 if (isMobileView()) {
//                     if(settings?.mobile?.truncateLabel && settings?.mobile?.maxLabelCharacters){

//                     }
//                 }
//                 else {
//                     if(settings?.web?.truncateLabel && settings?.web?.maxLabelCharacters){
//                         text =  text.length > settings?.web?.maxLabelCharacters ? text.substr(0, settings?.web?.maxLabelCharacters - 1) + '...' : text
//                     }
//                 }

//                 console.log(text, "::text");
//                 return [text, op.value]
//             },
//             offsetY: -4
//         },
//         tooltip: {
//             enabled: true,
//             y: {
//                 show: true,
//                 formatter: (val) => `${val}`
//             },
//             style: {
//                 fontSize: '18px',
//             }
//         }
//     };

//     if (!series?.length) {
//         return <div>No Data for given dimension and measure</div>
//     }

//     return (
//         <ReactApexChart
//             options={options}
//             series={series}
//             type="treemap"
//             height={500}
//         />
//     )
// }


// const handleChartLabel = (columnTitle, columnDisplayName, s) => {
//     let label;
//     let key = s?.key
//     let columnLabel = { ...columnDisplayName }
//     if (columnTitle && columnTitle.length && Object.keys(columnTitle[0]).length) {
//         for (let title of Object.keys(columnTitle[0])) {
//             if (columnTitle[0][title]) {
//                 columnLabel[title] = columnTitle[0][title]
//             }
//         }
//     }

//     if (key && columnLabel && Object.keys(columnLabel).length && columnLabel[key]) {
//         label = columnLabel[key]
//         if (Object.keys(columnLabel).length === 1) {
//             if (columnLabel[key].trim() === '') {
//                 label = label.replace(',', '')
//             }
//         }
//         else {
//             for (let index = 0; index < Object.keys(columnLabel).length; index++) {
//                 if (index !== 0) {
//                     if (key === Object.keys(columnLabel)[index] && columnLabel[Object.keys(columnLabel)[index - 1]].trim() === '') {
//                         label = columnLabel[key].replace(',', '')
//                     }
//                 }
//             }
//         }
//     }
//     else if (key && columnLabel && Object.keys(columnLabel).length) {
//         for (let col of Object.keys(columnLabel)) {
//             if (key.includes(col)) {
//                 let temp = key;
//                 if (columnLabel[col].trim() === '') {
//                     key = key.replace(`,${col}`, columnLabel[col]);
//                     if (temp === key) {
//                         key = key.replace(col, columnLabel[col]);
//                     }
//                 }
//                 else {
//                     key = key.replace(col, columnLabel[col]);
//                 }
//                 label = key;
//             }
//         }
//     }
//     else {
//         label = s?.title
//     }
//     return label;
// }


import React from "react";
import ReactECharts from 'echarts-for-react';
import { isMobileView, chartLegendIcon, roundOfToZero } from "../../utils/Reusables";

export default function BarChart(props) {
    const { resultSet, COLORS_SERIES, isLegendVisible, pivotConfig, dateFieldFormat, handleCategoryData, columnTitle, legendPosition, columnDisplayName, type, settings } = props;

    const series = resultSet.series(pivotConfig).map((s, index) => ({
        name: handleChartLabel(columnTitle, columnDisplayName, s),
        data: s?.series?.map((r, i) => {
            let dataObj = { name: r?.x, value: (r?.value === undefined || r?.value === null || r?.value === 'NaN' || r?.value === Infinity) ? 0 : roundOfToZero(r?.value,s?.key,settings) }
            return dataObj
        }),
        type: 'treemap',
        label: {
            show: settings?.showBarValueOnTop ?? true,
            position: settings?.barValuePosition ?? 'top',
            formatter: '{b}: {c}'
        },
        roam: false,
        nodeClick: false,
        leafDepth: null,
        breadcrumb: { show: false }
    }))


    let width = '80%'
    let legend = {}
    let gridOptions = {
        containLabel: true,
        left: 15,
        top: 17,
        right: 0,
        bottom: isLegendVisible ? 50 : 5
    }

    switch (legendPosition) {
        case 'right':
            legend = {
                orient: 'vertical',
                left: 'right',
                top: 0,
                type: isMobileView() ? (settings?.mobile?.legendPagination ? 'scroll' : 'plain') : (settings?.web?.legendPagination ? 'scroll' : 'plain'),
                show: isLegendVisible,
                icon: chartLegendIcon(),
                formatter: function (name) {
                    if (name?.length > 12) {
                        return name.substring(0, 12) + '...'
                    }
                    return name;
                },
                itemHeight: 20,
                textStyle: {
                    fontSize: 12,
                    lineHeight: 20,
                },
            }
            gridOptions = {
                width: '80%',
                height: '85%',
                top: 20,
                left: 15,
                right: '12%',
                bottom: 5,
                containLabel: true
            }


            if (settings?.web?.legendPagination && settings?.web?.maxLegendsCount && !isMobileView()) {
                legend.height = Number(settings?.web?.maxLegendsCount) * 30
            }
            else if (settings?.mobile?.legendPagination && settings?.mobile.maxLegendsCount && isMobileView()) {
                legend.height = Number(settings?.mobile.maxLegendsCount) * 30
            }
            else {
                delete legend?.height
            }

            break;
        case 'bottom':
            width = '93%'
            legend = {
                orient: 'horizontal',
                bottom: 0,
                left: '10px',
                itemGap: 10,
                type: isMobileView() ? (settings?.mobile?.legendPagination ? 'scroll' : 'plain') : (settings?.web?.legendPagination ? 'scroll' : 'plain'),
                show: isLegendVisible,
                icon: chartLegendIcon(),
                formatter: null,
                itemHeight: 20,
                textStyle: {
                    fontSize: 12,
                    lineHeight: 20,
                },
            }
            gridOptions = {
                top: 17,
                left: 15,
                right: 0,
                bottom: 50,
                containLabel: true,
            }


            if (settings?.web?.legendPagination && settings?.web?.maxLegendsCount && !isMobileView()) {
                legend.width = (Number(settings?.web?.maxLegendsCount) * 80) + 50
            }
            else if (settings?.mobile?.legendPagination && settings?.mobile?.maxLegendsCount && isMobileView()) {
                legend.width = (Number(settings?.mobile?.maxLegendsCount) * 80) + 50
            }
            else {
                delete legend?.width
            }

            break;
        case 'top':
            width = '93%'
            legend = {
                orient: 'horizontal',
                top: -6,
                left: '10px',
                type: isMobileView() ? (settings?.mobile?.legendPagination ? 'scroll' : 'plain') : (settings?.web?.legendPagination ? 'scroll' : 'plain'),
                show: isLegendVisible,
                icon: chartLegendIcon(),
                formatter: null,
                itemHeight: 20,
                textStyle: {
                    fontSize: 12,
                    lineHeight: 20,
                },
            }
            gridOptions = {
                top: 30,
                left: 15,
                right: 0,
                bottom: 5,
                containLabel: true
            }

            if (settings?.web?.legendPagination && settings?.web?.maxLegendsCount && !isMobileView()) {
                legend.width = (Number(settings?.web?.maxLegendsCount) * 80) + 50
            }
            else if (settings?.mobile?.legendPagination && settings?.mobile?.maxLegendsCount && isMobileView()) {
                legend.width = (Number(settings?.mobile?.maxLegendsCount) * 80) + 50
            }
            else {
                delete legend?.width
            }

            break;
        case 'left':
            legend = {
                orient: 'vertical',
                left: 'left',
                top: 0,
                type: isMobileView() ? (settings?.mobile?.legendPagination ? 'scroll' : 'plain') : (settings?.web?.legendPagination ? 'scroll' : 'plain'),
                show: isLegendVisible,
                icon: chartLegendIcon(),
                formatter: function (name) {
                    if (name?.length > 12) {
                        return name.substring(0, 12) + '...'
                    }
                    return name;
                },
                itemHeight: 20,
                textStyle: {
                    fontSize: 12,
                    lineHeight: 20,
                },
            }
            gridOptions = {
                top: 20,
                left: '17%',
                right: 0,
                bottom: 5,
                containLabel: true,
            }

            if (settings?.web?.legendPagination && settings?.web?.maxLegendsCount && !isMobileView()) {
                legend.height = Number(settings?.web?.maxLegendsCount) * 30
            }
            else if (settings?.mobile?.legendPagination && settings?.mobile?.maxLegendsCount && isMobileView()) {
                legend.height = Number(settings?.mobile?.maxLegendsCount) * 30
            }
            else {
                delete legend?.height
            }
            break;
    }

    if (!isLegendVisible) {
        width = '93%'
        legend = {
            show: false,
        }
        gridOptions = {
            containLabel: true,
            left: 17,
            top: 17,
            right: 0,
            bottom: 5
        }
    }

    let axisLabel = {
        rotate: 65,
        width: isMobileView() ? 90 : 120,
        overflow: "truncate",
        lineOverflow: 'truncate',
    }


    if (isMobileView()) {
        axisLabel.overflow = settings?.mobile?.truncateLabel ? 'truncate' : 'none'
        axisLabel.lineOverflow = settings?.mobile?.truncateLabel ? 'truncate' : 'none'
        axisLabel.width = Number(settings?.mobile?.maxLabelCharacters) * 10
    }
    else {
        axisLabel.overflow = settings?.web?.truncateLabel ? 'truncate' : 'none'
        axisLabel.lineOverflow = settings?.web?.truncateLabel ? 'truncate' : 'none'
        axisLabel.width = Number(settings?.web?.maxLabelCharacters) * 10
    }


    let options = {
        tooltip: {},
        grid: gridOptions,
        legend: legend,
        series,
        width,
    };


    return (
        <div>
            <ReactECharts style={{ height: isMobileView() ? (isLegendVisible ? '260px' : '300px') : '300px' }} option={options} opts={{ renderer: 'svg' }} />
        </div>
    )
}

const handleChartLabel = (columnTitle, columnDisplayName, s) => {
    let label;
    let key = s?.key
    let columnLabel = { ...columnDisplayName }
    if (columnTitle && columnTitle.length && Object.keys(columnTitle[0]).length) {
        for (let title of Object.keys(columnTitle[0])) {
            if (columnTitle[0][title]) {
                columnLabel[title] = columnTitle[0][title]
            }
        }
    }

    if (key && columnLabel && Object.keys(columnLabel).length && columnLabel[key]) {
        label = columnLabel[key]
        if (Object.keys(columnLabel).length === 1) {
            if (columnLabel[key].trim() === '') {
                label = label.replace(',', '')
            }
        }
        else {
            for (let index = 0; index < Object.keys(columnLabel).length; index++) {
                if (index !== 0) {
                    if (key === Object.keys(columnLabel)[index] && columnLabel[Object.keys(columnLabel)[index - 1]].trim() === '') {
                        label = columnLabel[key].replace(',', '')
                    }
                }
            }
        }
    }
    else if (key && columnLabel && Object.keys(columnLabel).length) {
        for (let col of Object.keys(columnLabel)) {
            if (key.includes(col)) {
                let temp = key;
                if (columnLabel[col].trim() === '') {
                    key = key.replace(`,${col}`, columnLabel[col]);
                    if (temp === key) {
                        key = key.replace(col, columnLabel[col]);
                    }
                }
                else {
                    key = key.replace(col, columnLabel[col]);
                }
                label = key;
            }
        }
    }
    else {
        label = s?.title
    }
    return label;
}
